var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.94H1M5.242 19.182L1 14.939l4.242-4.242M1 5.242h20M16.758 1L21 5.242l-4.242 4.243",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgStatusTransfer;